import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ClosableModalWithErrorResponseModel } from '../../../shared/components/base/closable-modal-with-error-response-model';

import { NotificationService, FunctionalAnalysesService } from '../../../shared/services';
import { ModalService } from '../../../shared/modules/modal';

import { CreateFunctionalAnalysisTemplateModalPayload, SaveLibraryDataPayload } from '../../../shared/models';

@Component({
  templateUrl: './create-functional-analysis-template-modal.component.html'
})
export class CreateFunctionalAnalysisTemplateModalComponent extends ClosableModalWithErrorResponseModel<void> {

  data: CreateFunctionalAnalysisTemplateModalPayload;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _functionalAnalysesService: FunctionalAnalysesService
  ) {
    super(notificationService, modalService);

    this.templateNameAlreadyExists = this.templateNameAlreadyExists.bind(this);
    this.createGlobalTemplate = this.createGlobalTemplate.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  templateNameAlreadyExists(templateName: string): Observable<boolean> {
    return this._functionalAnalysesService.templateAlreadyExists(this.data.analysisType, templateName);
  };

  createGlobalTemplate(payload: SaveLibraryDataPayload): Observable<any> {
    return this._functionalAnalysesService.createGlobalTemplate(this.data.analysisType, this.data.resourceId, payload).pipe(
      tap(() => {
        this.success();
        this.closeModal();
      })
    );
  };

  closeModal(): void {
    this.closeAllModals();
  };

}
